module.exports = __webpack_public_path__ + "img/cq4.e700b8b8.jpg";